import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store/store';
import { ILenderFooterState } from '../../modules/ContactManager/components/Tabs/shared/DealCalculator/interfaces';

interface IDealCalculatorInitialState {
  footerLender: Partial<ILenderFooterState> | null;
  salesTax?: number;
}

const initialState: IDealCalculatorInitialState = {
  footerLender: null,
};

export const dealCalculatorSlice = createSlice({
  name: 'dealCalculator',
  initialState,
  reducers: {
    setFooterLenderAction: (state, action: PayloadAction<Partial<ILenderFooterState>>) => {
      state.footerLender = { ...state.footerLender, ...action.payload };
    },
  },
});

export const { setFooterLenderAction } = dealCalculatorSlice.actions;

export const footerLenderSelector = (state: RootState) => state.dealCalculator.footerLender;
